import { connect } from 'react-redux'
import FilterList from 'pages/mwdealcompare/FilterList'

const mapStateToProps = state => ({
  windowHeight: state.layout.windowHeight,
  headerHeight: state.layout.headerHeight,
  isTablet: state.layout.deviceType.isTablet
})

export default connect(mapStateToProps, null)(FilterList)
